module.exports = __webpack_public_path__ + "static/media/flag management skills.dcee0d84.svg";